export default __webpack_public_path__ + "static/IconPredios-613ef7993822b639fc4f62d85471fda3.svg";